import React from 'react';
import { Field, inputClass } from './BackgroundFields';

/**
 * Forme et arrondi des onglets / boutons menu.
 * @param {object} props
 * @param {string} [props.shape]
 * @param {number} [props.borderRadius]
 * @param {(shape: string) => void} props.onChangeShape
 * @param {(radius: number) => void} props.onChangeRadius
 * @param {boolean} [props.showInherit] — option « Défaut du menu » (surcharge par entrée)
 * @param {string} [props.inheritShape] — forme effective du menu (aperçu arrondi)
 * @param {number} [props.inheritRadius]
 */
export default function MenuTabShapeFields({
  shape,
  borderRadius,
  onChangeShape,
  onChangeRadius,
  showInherit = false,
  inheritShape = 'rounded',
  inheritRadius = 8,
}) {
  const shapeValue = showInherit ? shape ?? '' : shape || 'rounded';
  const effectiveShape = shapeValue || inheritShape || 'rounded';
  const radiusValue =
    borderRadius != null && borderRadius !== ''
      ? Number(borderRadius)
      : showInherit
        ? inheritRadius
        : Number(borderRadius ?? 8);

  const showRadiusControl =
    effectiveShape === 'rounded' || effectiveShape === 'custom';

  return (
    <>
      <Field label="Forme des coins">
        <select
          className={inputClass}
          value={shapeValue}
          onChange={(e) => onChangeShape(e.target.value)}
        >
          {showInherit ? <option value="">Défaut du menu</option> : null}
          <option value="square">Carré (0 px)</option>
          <option value="rounded">Arrondi</option>
          <option value="pill">Pilule</option>
        </select>
      </Field>
      {showRadiusControl ? (
        <Field label={`Arrondi des coins (${radiusValue} px)`}>
          <input
            type="range"
            min={0}
            max={40}
            step={1}
            className="w-full mb-2"
            value={radiusValue}
            onChange={(e) => onChangeRadius(Number(e.target.value) || 0)}
          />
          <input
            type="number"
            min={0}
            max={40}
            className={inputClass}
            value={radiusValue}
            onChange={(e) => onChangeRadius(Number(e.target.value) || 0)}
          />
        </Field>
      ) : effectiveShape === 'pill' ? (
        <p className="text-[11px] text-muted-foreground">Pilule : coins entièrement arrondis.</p>
      ) : null}
    </>
  );
}
